import AuthorizationError from '@/common/utils/errors/AuthorizationError';
import { TotpStatus } from '@schema';
import { OPENSTACK_AUTH_RECEIPT_HEADER } from '@/common/constants/auth.constants';

export default class TotpAuthorizationError extends AuthorizationError {
  totpReceipt?: string;
  totpStatus?: string;
  isSetupRequired = false;

  constructor(response?: Response, body?: ErrorBody) {
    super(response, body);

    const error = (body as any)?.error ?? body ?? {};
    const { message, totp_status } = error;

    this.totpReceipt = response?.headers?.get(OPENSTACK_AUTH_RECEIPT_HEADER) ?? undefined;
    this.totpStatus = totp_status;
    this.isSetupRequired = totp_status === TotpStatus.status.ENFORCED;

    this.message = message
      ?? response?.statusText
      ?? 'TOTP authentication required';
  }
}
